import React from 'react';
import styled, { ThemeProvider, withTheme } from 'styled-components';
import { ThemeSelector } from '../components';

const Head = styled.div`
  display: flex;
  height: 50px;
  background: ${props => props.theme.bg};
`;

const Left = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  padding: 5px;
  color: ${props => props.theme.top.title};
  font-size: 13px;
`;

const Right = styled.div`
  flex: 1;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 5px;
`;

const BotBar = ({ theme, selectTheme, selectedTheme }) => (
  <ThemeProvider theme={theme}>
    <Head>
      <Left>&copy; Coinmend 2019</Left>
      <Right>
        <ThemeSelector selectTheme={selectTheme} selectedTheme={selectedTheme} />
      </Right>
    </Head>
  </ThemeProvider>
);

export default withTheme(BotBar);



// WEBPACK FOOTER //
// ./src/components/BotBar.js